class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    // OMO: a details that is still fading out counts as closed, so a quick re-click reopens it.
    details.hasAttribute('open') && !details.classList.contains('is-closing') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    // OMO: cancel a pending fade-out and measure the scrollbar the scroll lock is about to remove,
    // so omo-search.css can keep the fixed header's box (logo/nav/X) exactly where it was.
    clearTimeout(this.closeTimer);
    this.detailsContainer.classList.remove('is-closing');
    document.documentElement.style.setProperty(
      '--omo-scrollbar-width',
      `${window.innerWidth - document.documentElement.clientWidth}px`
    );
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.removeProperty('--omo-scrollbar-width');
    // OMO desktop: let the search wash fade out before the details closes; instant elsewhere.
    if (window.matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)').matches) {
      this.detailsContainer.classList.add('is-closing');
      this.closeTimer = setTimeout(() => {
        this.detailsContainer.classList.remove('is-closing');
        this.detailsContainer.removeAttribute('open');
      }, 180);
    } else {
      this.detailsContainer.removeAttribute('open');
    }
  }
}

customElements.define('details-modal', DetailsModal);
